function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40,18.36l2.07,1.63,2,1.57,2.45-.69,2.53-.71,1.29,2.29,1.24,2.22,2.53.3,2.61.31.31,2.61.3,2.53,2.22,1.24,2.29,1.29-.71,2.53-.69,2.45,1.57,2,1.63,2.07-1.63,2.07-1.57,2,.69,2.45.71,2.53-2.29,1.29-2.22,1.24-.3,2.53-.31,2.61-2.61.31-2.53.3-1.24,2.22-1.29,2.29-2.53-.71-2.45-.69-2,1.57-2.07,1.63-2.07-1.63-2-1.57-2.45.69-2.53.71-1.29-2.29-1.24-2.22-2.53-.3-2.61-.31-.31-2.61-.3-2.53-2.22-1.24-2.29-1.29.71-2.53.69-2.45-1.57-2-1.63-2.07,1.63-2.07,1.57-2-.69-2.45-.71-2.53,2.29-1.29,2.22-1.24.3-2.53.31-2.61,2.61-.31,2.53-.3,1.24-2.22,1.29-2.29,2.53.71,2.45.69,2-1.57,2.07-1.63M40,12l-5.16,4.06-6.32-1.78-3.21,5.73-6.52.77-.77,6.52-5.73,3.21,1.78,6.32-4.06,5.16,4.06,5.16-1.78,6.32,5.73,3.21.77,6.52,6.52.77,3.21,5.73,6.32-1.78,5.16,4.06,5.16-4.06,6.32,1.78,3.21-5.73,6.52-.77.77-6.52,5.73-3.21-1.78-6.32,4.06-5.16-4.06-5.16,1.78-6.32-5.73-3.21-.77-6.52-6.52-.77-3.21-5.73-6.32,1.78-5.16-4.06h0Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "48.93 29.44 37.23 43.46 32.02 37.47 25.98 42.71 37.35 55.79 55.07 34.56 48.93 29.44 48.93 29.44"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Editors-inactive.4645c343.svg";
export { SvgComponent as ReactComponent };